export class Telefono {
    idTelefono: string;
    telefono: string;
    claveTipoTelefono: string;
}